var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('h1',[_c('v-icon',{attrs:{"color":"red","size":"45"}},[_vm._v("mdi-file-chart")]),_vm._v("Pre-Diagnóstico Dinámico")],1),_c('massive-folio-report-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }